import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.html',
  styleUrls: ['./disclaimer.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DisclaimerComponent {}
